import Model from './model';

export default class ExperienceEntry extends Model {
  static NAME = 'experience_entry';
  static COLLECTION_NAME = "experience_entries";
  static URL = '/api/v2/experience_entries';
}
